@if (!expanded() && !showConfirmApplicable() && !showConfirmNotApplicable()) {
  <section class="workspace-surface collapsible">
    <button
      type="button"
      class="collapse-section"
      [class.collapse-section-expanded]="isApplicabilityInfoExpanded()"
      [attr.aria-expanded]="isApplicabilityInfoExpanded()"
      (click)="toggleApplicabilityInfo()"
    >
      @if (isApplicable()) {
        <ng-container [ngTemplateOutlet]="applicableCollapsed"></ng-container>
      } @else {
        <ng-container [ngTemplateOutlet]="notApplicableCollapsed"></ng-container>
      }
    </button>
    <div
      class="content-area-wrapper"
      [class.content-area-wrapper-expanded]="isApplicabilityInfoExpanded()"
    >
      <div class="content-area">
        <p>{{ notApplicableJustification() }}</p>
        <div class="action-row uls">
          <button
            comp-button="tertiary"
            (click)="expand()"
            translate="requirementIntake.applicability.decision.again"
          ></button>
        </div>
      </div>
    </div>
  </section>
} @else {
  <section class="workspace-surface">
    <h4 class="surface-title uppercase">
      {{ 'requirementIntake.applicability.title' | translate }}
    </h4>

    <div
      class="choice-tiles"
      role="group"
      [attr.aria-label]="'requirementIntake.applicability.aria.selection' | translate"
    >
      <button
        type="button"
        class="choice-tile"
        [class.selected]="isApplicable()"
        [attr.aria-pressed]="isApplicable()"
        (click)="selectApplicable()"
      >
        <span class="choice-icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </span>
        <span class="choice-body">
          <span class="choice-title">{{
            'requirementIntake.applicability.applicable.title' | translate
          }}</span>
          <span class="choice-hint">{{
            'requirementIntake.applicability.applicable.hint' | translate
          }}</span>
        </span>
      </button>

      <button
        type="button"
        class="choice-tile na"
        [class.selected]="isNotApplicable()"
        [attr.aria-pressed]="isNotApplicable()"
        (click)="selectNotApplicable()"
      >
        <span class="choice-icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
          </svg>
        </span>
        <span class="choice-body">
          <span class="choice-title">{{
            'requirementIntake.applicability.notApplicable.title' | translate
          }}</span>
          <span class="choice-hint">{{
            'requirementIntake.applicability.notApplicable.hint' | translate
          }}</span>
        </span>
      </button>
    </div>
    <div
      class="na-justify"
      [class.visible]="isNotApplicable()"
      [attr.aria-hidden]="!isNotApplicable()"
    >
      <div class="na-justify-inner">
        <label class="field-label" for="notApplicableJustification">
          {{ 'requirementIntake.applicability.justification.label' | translate }}
        </label>
        <textarea
          id="notApplicableJustification"
          [disabled]="!isNotApplicable()"
          [value]="notApplicableJustification()"
          (input)="onNotApplicableJustificationInput($event)"
          rows="3"
          [placeholder]="'requirementIntake.applicability.justification.placeholder' | translate"
          [compAutofocus]="isNotApplicable()"
        ></textarea>

        @if (isNotApplicableJustificationMissing()) {
          <p class="field-error">
            {{ 'requirementIntake.applicability.justification.requiredError' | translate }}
          </p>
        }

        @if (showConfirmNotApplicable()) {
          <div class="action-row uls">
            <button
              comp-button
              type="button"
              [disabled]="!canConfirmNotApplicable() || isSubmitPending()"
              (click)="confirmNotApplicable()"
            >
              {{
                isSubmitPending()
                  ? ('requirementIntake.actions.confirming' | translate)
                  : ('requirementIntake.actions.confirmNotApplicable' | translate)
              }}
            </button>
          </div>
        }
      </div>
    </div>

    @if (showConfirmApplicable()) {
      <div class="action-row uls">
        <button
          comp-button
          type="button"
          [disabled]="!canConfirmApplicable() || isSubmitPending()"
          (click)="confirmApplicable()"
        >
          {{
            isSubmitPending()
              ? ('requirementIntake.actions.confirming' | translate)
              : ('requirementIntake.actions.confirmApplicable' | translate)
          }}
        </button>
      </div>
    }

    @if (actionMessage(); as message) {
      <p class="workspace-caption">{{ message }}</p>
    }
  </section>
}

<ng-template #applicableCollapsed>
  <div class="icon applicable">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
  </div>
  <span translate="requirementIntake.applicability.decision.applicable"></span>
  <svg class="chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M6 9l6 6 6-6"
      stroke="currentColor"
      fill="none"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>

<ng-template #notApplicableCollapsed>
  <div class="icon not-applicable">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
    </svg>
  </div>
  <span translate="requirementIntake.applicability.decision.notApplicable"></span>
  <svg class="chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M6 9l6 6 6-6"
      stroke="currentColor"
      fill="none"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>
